var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.4237 27.9999L11.5337 26.6159C10.8297 26.5412 10.3784 26.1679 10.1797 25.4959C9.98106 24.8239 10.1431 24.2559 10.6657 23.7919L30.2317 6.23191C30.3211 6.14125 30.4244 6.07391 30.5417 6.02991C30.6591 5.98458 30.8284 5.96191 31.0497 5.96191C31.4097 5.96191 31.6937 6.11725 31.9017 6.42791C32.1097 6.73858 32.1117 7.06525 31.9077 7.40791L24.4617 20.0379L36.4277 21.4219C37.1317 21.4966 37.5897 21.8632 37.8017 22.5219C38.0137 23.1806 37.8577 23.7426 37.3337 24.2079L17.7677 41.8079C17.6784 41.8972 17.5751 41.9579 17.4577 41.9899C17.3404 42.0219 17.1711 42.0379 16.9497 42.0379C16.5897 42.0379 16.3184 41.8832 16.1357 41.5739C15.9531 41.2646 15.9511 40.9506 16.1297 40.6319L23.4237 27.9999ZM21.0237 36.0339L35.3817 23.2959L21.2377 21.7119L27.0417 11.8999L12.6177 24.6779L26.7117 26.3659L21.0237 36.0339Z",
    fill: "#3B3B58"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.5a8e33a3714c6a12ea0ca896afd08c26.svg";
export { ForwardRef as ReactComponent };